import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
import { spacingBreakpoint } from "./armor-system-QCYY7333.js";
import { __objRest } from "./armor-system-JQVN7XCJ.js";

// src/properties/size.ts
import { css } from "styled-components";
var makeCSS = function makeCSS(cssParameter, value) {
  if (typeof value !== "undefined") {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n            ", ": ", ";\n        "])), cssParameter, spacingBreakpoint(value));
  }
  return "";
};
var widthProps = function widthProps(_ref) {
  var width = _ref.width,
    minWidth = _ref.minWidth,
    maxWidth = _ref.maxWidth,
    wide = _ref.wide;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n"])), makeCSS("width", width), makeCSS("min-width", minWidth), makeCSS("max-width", maxWidth), wide ? "width: 100%;" : "");
};
var heightProps = function heightProps(_ref2) {
  var height = _ref2.height,
    minHeight = _ref2.minHeight,
    maxHeight = _ref2.maxHeight,
    tall = _ref2.tall;
  return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n"])), makeCSS("height", height), makeCSS("min-height", minHeight), makeCSS("max-height", maxHeight), tall ? "height: 100%;" : "");
};
var sizeProps = function sizeProps(props) {
  return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n"])), widthProps(props), heightProps(props));
};
var extractSizeProps = function extractSizeProps(_a) {
  var _b = _a,
    width = _b.width,
    minWidth = _b.minWidth,
    maxWidth = _b.maxWidth,
    wide = _b.wide,
    height = _b.height,
    minHeight = _b.minHeight,
    maxHeight = _b.maxHeight,
    tall = _b.tall,
    restSizeProps = __objRest(_b, ["width", "minWidth", "maxWidth", "wide", "height", "minHeight", "maxHeight", "tall"]);
  return {
    restSizeProps: restSizeProps,
    sizeProps: {
      width: width,
      minWidth: minWidth,
      maxWidth: maxWidth,
      wide: wide,
      height: height,
      minHeight: minHeight,
      maxHeight: maxHeight,
      tall: tall
    }
  };
};
export { widthProps, heightProps, sizeProps, extractSizeProps };